import { parse, isMatch, isValid } from 'date-fns';

const VARIABLE_LENGTH_FORMATS = [
  "yyM",
  "yyMd",
  "yyMdd",
  "yyyyM",
  "yyyyMd",
  "yyyyMdd",
  "yyyyMMd"
];
const VARIABLE_FORMAT_RECORD = {
  yyM: "yy/M",
  yyMd: "yy/M/d",
  yyMdd: "yy/M/dd",
  yyyyM: "yyyy/M",
  yyyyMd: "yyyy/M/d",
  yyyyMdd: "yyyy/M/dd",
  yyyyMMd: "yyyy/MM/d"
};
const FORMAT_PRIORITY = [
  // 고정 길이 포맷 (우선순위 높음)
  "yyyyMMdd",
  "yyMMdd",
  "yyMM",
  "yyyyMM",
  "yy",
  "yyyy",
  // 구분자가 있는 포맷
  "yyyy-MM-dd",
  "yy-MM-dd",
  "yyyy/MM/dd",
  "yy/MM/dd",
  "yyyy.MM.dd",
  "yy.MM.dd",
  "yyyy-MM-d",
  "yy-MM-d",
  "yyyy/MM/d",
  "yy/MM/d",
  "yyyy.MM.d",
  "yy.MM.d",
  "yyyy-M-dd",
  "yy-M-dd",
  "yyyy/M/dd",
  "yy/M/dd",
  "yyyy.M.dd",
  "yy.M.dd",
  "yyyy-M-d",
  "yy-M-d",
  "yyyy/M/d",
  "yy/M/d",
  "yyyy.M.d",
  "yy.M.d",
  "yyyy-MM",
  "yy-MM",
  "yyyy/MM",
  "yy/MM",
  "yyyy.MM",
  "yy.MM",
  "yyyy-M",
  "yy-M",
  "yyyy/M",
  "yy/M",
  "yyyy.M",
  "yy.M",
  // 한글 포맷
  "yyyy\uB144MM\uC6D4dd\uC77C",
  "yy\uB144MM\uC6D4dd\uC77C",
  "yyyy\uB144MM\uC6D4d\uC77C",
  "yy\uB144MM\uC6D4d\uC77C",
  "yyyy\uB144M\uC6D4dd\uC77C",
  "yy\uB144M\uC6D4dd\uC77C",
  "yyyy\uB144M\uC6D4d\uC77C",
  "yy\uB144M\uC6D4d\uC77C",
  "yyyy\uB144MM\uC6D4",
  "yy\uB144MM\uC6D4",
  "yyyy\uB144M\uC6D4",
  "yy\uB144M\uC6D4",
  "yyyy\uB144",
  // 가변 길이 포맷 (우선순위 낮음, 2자리 년도 우선)
  "yyMMd",
  // 25121 → 2025-12-1 (이게 우선)
  "yyMdd",
  // 25101 → 2025-1-01
  "yyyyMMd",
  // 202512 → 2025-1-2
  "yyMd",
  // 2512 → 2025-1-2
  "yyyyMdd",
  // 2025101 → 2025-10-1
  "yyyyMd",
  // 202512 → 2025-1-2 (우선순위 가장 낮음)
  "yyyyM",
  // 20251 → 2025-1
  "yyM"
  // 251 → 2025-1
];
function normalizeValue(value, format) {
  const hasSpaces = /\s/.test(value);
  const isVariableFormat = VARIABLE_LENGTH_FORMATS.includes(format);
  return value.replace(/\s+/g, hasSpaces && isVariableFormat ? "/" : "");
}
function getParseFormat(originalFormat, hasSpaces) {
  const isVariableFormat = VARIABLE_LENGTH_FORMATS.includes(originalFormat);
  const parseFormat = VARIABLE_FORMAT_RECORD[originalFormat];
  return hasSpaces && isVariableFormat && parseFormat !== void 0 ? parseFormat : originalFormat;
}
function isReasonableDate(date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  if (year < 1900 || year > 2100) {
    return false;
  }
  if (month < 1 || month > 12) {
    return false;
  }
  if (day < 1 || day > 31) {
    return false;
  }
  return true;
}
function findMostSimilarDateFormat(params) {
  const { value, patterns, referenceDate, inputType } = params;
  const validCandidates = [];
  Object.entries(patterns).forEach(([format, regex]) => {
    if (!regex.test(value)) {
      return;
    }
    const normalizedValue = normalizeValue(value, format);
    const parseFormat = getParseFormat(format, /\s/.test(value));
    if (!isMatch(normalizedValue, parseFormat)) {
      return;
    }
    const parsedDate = parse(normalizedValue, parseFormat, referenceDate);
    if (!isValid(parsedDate) || !isReasonableDate(parsedDate)) {
      return;
    }
    if (inputType === "year" && (format.includes("M") || format.includes("d"))) {
      return;
    }
    validCandidates.push({ format, parsedDate });
  });
  if (validCandidates.length === 0) {
    return null;
  }
  for (const priorityFormat of FORMAT_PRIORITY) {
    const found = validCandidates.find((c) => c.format === priorityFormat);
    if (found) {
      return found.format;
    }
  }
  return validCandidates[0]?.format ?? null;
}
function normalizeDateInput(params) {
  const { value, patterns, referenceDate, inputType } = params;
  const format = findMostSimilarDateFormat({
    value,
    patterns,
    referenceDate,
    inputType
  });
  if (format === null) {
    return null;
  }
  const normalizedValue = normalizeValue(value, format);
  const parseFormat = getParseFormat(format, /\s/.test(value));
  const result = parse(normalizedValue, parseFormat, referenceDate);
  if (format.includes("yy") && !format.includes("yyyy")) {
    const year = result.getFullYear();
    if (year < 1950) {
      result.setFullYear(year + 100);
    }
  }
  return result;
}

export { normalizeDateInput };
//# sourceMappingURL=normalize.mjs.map
